import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrder } from '../../../contexts/OrderContext'
import { useCart } from '../../../contexts/CartContext'
import { getCartSubTotal, validateCouponCode } from '../../../utils/coupon'
import { OutlineBtn } from '../../Shared/Buttons'
import {
  PromoCodeContainer,
  PromoHeader,
  CodeContainer,
  CodeInput,
  ErrorMsg
} from './styles'

export const PromoCode = () => {
  const { t } = useTranslation();
  const [orderDetail, { updateOrder }] = useOrder();
  const [cart] = useCart();
  const [code, setCode] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const saved =
      orderDetail?.coupon?.appliedCode || orderDetail?.coupon?.couponName
    if (saved) setCode(saved)
  }, [])

  useEffect(() => {
    if (orderDetail?.promoCodeError) {
      setIsError(true)
      updateOrder({ promoCodeError: false })
    }
  }, [orderDetail?.promoCodeError, updateOrder])

  const handleChange = (e) => {
    setCode(e.target.value);
    if (isError) setIsError(false)
  }

  const handleClickApply = async () => {
    const subTotal = getCartSubTotal(cart)
    try {
      const validated = await validateCouponCode(code, subTotal)
      if (validated) {
        updateOrder({ coupon: validated, promoCodeError: false });
        setIsError(false);
        return
      }
      updateOrder({ coupon: null, promoCodeError: true });
      setIsError(true);
    } catch (err) {
      console.log(err, 'coupon code error')
      updateOrder({ coupon: null, promoCodeError: true });
      setIsError(true);
    }
  }

  return (
    <PromoCodeContainer>
      <PromoHeader>
        {t('Promo Code')}
      </PromoHeader>
      <CodeContainer>
        <CodeInput type='text' placeholder={t('Enter discount code')} value={code} onChange={handleChange} />
        <OutlineBtn color="#bb6600" disabled={!code} onClick={handleClickApply}>
          {t('Apply')}
        </OutlineBtn>
      </CodeContainer>
      <ErrorMsg active={isError}>  {t('Promo Code Error')} </ErrorMsg>
    </PromoCodeContainer>
  )
}